import { jsx as _jsx } from "react/jsx-runtime";
import { EmployeeHome } from '@src/components/Employee/EmployeeHome';
import { useAuth } from '@src/hooks/useAuth';
import { Navigate } from 'react-router-dom';
import './Home.scss';
export const Home = () => {
    const { currentUser, isClaimsProcessor, isSuperuser, loading, isMemberSupport, isManager, isEmployee, } = useAuth();
    if (!loading && !currentUser)
        return _jsx(Navigate, { to: '/login' });
    if (isSuperuser)
        return _jsx(Navigate, { to: '/admin' });
    if (isClaimsProcessor || isMemberSupport)
        return _jsx(Navigate, { to: '/admin/claims' });
    if (isManager && !isEmployee)
        return _jsx(Navigate, { to: '/tasks' });
    if (currentUser && currentUser.employeeId)
        return _jsx(EmployeeHome, {});
    return _jsx("div", { className: 'home' });
};
